import React from "react";
import { ReactComponent as PriorityIcon } from "@coworker/reusable/svg/priority-exclamation-sign.svg";

export function Priority() {
  return <PriorityIcon />;
}
